import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { isNativeApp } from '../utils/nativeAuth';

// Receives legacyforge://auth#session_id=... after Google sign-in in the phone's browser
export function NativeDeepLinkListener() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return undefined;
    const handle = CapApp.addListener('appUrlOpen', async ({ url }) => {
      const hashIndex = url.indexOf('#');
      const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
      try { await Browser.close(); } catch { /* already closed */ }
      if (hash.includes('session_id=')) navigate(`/dashboard${hash}`, { replace: true });
    });
    return () => { handle.then(h => h.remove()); };
  }, [navigate]);

  return null;
}
